import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ConstructionPage, { isConstructionUnlocked } from "@/pages/ConstructionPage";

/**
 * Wraps PUBLIC routes. If construction mode is active AND the client is not
 * unlocked (localStorage flag), renders the ConstructionPage instead of the
 * children.
 *
 * NOT applied to /login, /admin, /formateur, /stagiaire or /api/*.
 */
export default function ConstructionGate({ children }) {
    // "unknown" = still checking, "pass" = allowed through, "block" = show construction
    const [state, setState] = useState("unknown");

    useEffect(() => {
        let alive = true;
        async function check() {
            // Quick client-side hit first to avoid a network flash for returning visitors
            if (isConstructionUnlocked()) {
                if (alive) setState("pass");
                return;
            }
            try {
                const { data } = await api.get("/construction/status");
                if (!alive) return;
                if (!data.active) {
                    setState("pass");
                } else {
                    setState("block");
                }
            } catch {
                // If the backend is unreachable, fail open so the site stays accessible.
                if (alive) setState("pass");
            }
        }
        check();
        return () => { alive = false; };
    }, []);

    if (state === "unknown") {
        return (
            <div className="flex min-h-screen items-center justify-center bg-[#33333A] text-white/40 text-sm">
                Chargement…
            </div>
        );
    }
    if (state === "block") {
        return <ConstructionPage onUnlock={() => setState("pass")} />;
    }
    return children;
}
